<template>
  <app-spinner v-if="loading > 0"></app-spinner>
  <main class="page-content pt-0" v-else>
    <!-- Start Carousel 3d -->
    <div v-if="getContentSlides">
      <carousel-3d id="carousel3d"
                   :autoplay="true"
                   :autoplayTimeout="5000"
                   :autoplayHoverPause="true"
                   :controls-visible="true"
                   :controls-prev-html="'&#10092;'"
                   :controls-next-html="'&#10093;'"
                   :controls-width="30"
                   :controls-height="60"
                   :clickable="true">
        <slide :index="index"
               class="text-white"
               :key="'slide-'+index"
               v-for="(contentSlide, index) in getContentSlides">
          <app-content-slide :contentSlide="contentSlide" :page=0></app-content-slide>
        </slide>
      </carousel-3d>
    </div>
    <!-- End Carousel 3d -->
    <div class="section-full book-form overlay-black-dark bg-img-fix p-t30 p-b10 mid" style="background-image:url(../assets/img/background/bg1.jpg);">
      <div class="container">
        <form method="post" action="">
          <div class="row">
            <div class="col-6 col-sm-4 col-lg-3 form-group">
              <label for="search_min_amount">Prix ($)</label>
              <input id="search_min_amount" name="min_amount" class="form-control" placeholder="Indiquez votre prix" type="number" required>
            </div>
            <div class="col-6 col-sm-4 col-lg-3 form-group">
              <label for="search_service">Service</label>
              <select class="form-control" name="service_id" id="search_service" required>
                <option value="tout">Tout</option>
                <option value="hotels">Hôtels</option>
                <option value="restaurants">Restaurants</option>
                <option value="tourisme">Tourisme</option>
              </select>
            </div>
            <div class="col-6 col-sm-4 col-lg-3 form-group">
              <label>Réchercher</label>
              <button type="submit" class="site-button btn-block text-uppercase">Réchercher</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Search Results START -->
    <div class="section-full bg-white content-inner dlab-about-1 promotions" id="about-us">
      <div class="container">
        <div class="section-head text-center">
          <h2 class="text-uppercase m-b0">Résultats (4)</h2>
          <p class="font-18">LES OFFRES CORESPONDANT &Agrave; VOS CRIT&Egrave;RES DE RECHERCHE</p>
        </div>
        <div class="row packages">
          <div class="col-sm-6 col-md-6 col-xl-3 m-b30">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../assets/img/upload_images/offers/exposition.png" alt=""></a>
              </div>
              <div class="dlab-info p-a15 border-1">
                <h4 class="dlab-title m-t0"><a href="">Tableaux des bonobos</a></h4>
                <span class="location">Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</span>
                <div class="package-content">
                  <ul class="package-meta">
                    <li><span class="fa fa-handshake-o"></span> Service : Expositon</li>
                  </ul>
                  <div class="d-flex flex-column">
                    <span class="package-price text-primary text-center">5$ <em class="font-weight-normal font-16">(5%)</em></span>
                    <div class="mt-3 d-flex flex-row justify-content-around">
                      <router-link to="reservation" title="Réserver cette offre" class="site-button outline outline-2 radius-xl">Réserver</router-link>
                      <a title="Enregistrer cette offre" href="#" class="site-button outline outline-2 radius-xl site-button-customized"><i class="la la-save"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xl-3 m-b30">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../assets/img/upload_images/offers/exposition.png" alt=""></a>
              </div>
              <div class="dlab-info p-a15 border-1">
                <h4 class="dlab-title m-t0"><a href="">Tableaux des bonobos</a></h4>
                <span class="location">Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</span>
                <div class="package-content">
                  <ul class="package-meta">
                    <li><span class="fa fa-handshake-o"></span> Service : Expositon</li>
                  </ul>
                  <div class="d-flex flex-column">
                    <span class="package-price text-primary text-center">5$ <em class="font-weight-normal font-16">(5%)</em></span>
                    <div class="mt-3 d-flex flex-row justify-content-around">
                      <router-link to="reservation" title="Réserver cette offre" class="site-button outline outline-2 radius-xl">Réserver</router-link>
                      <a title="Enregistrer cette offre" href="#" class="site-button outline outline-2 radius-xl site-button-customized"><i class="la la-save"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xl-3 m-b30">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../assets/img/upload_images/offers/exposition.png" alt=""></a>
              </div>
              <div class="dlab-info p-a15 border-1">
                <h4 class="dlab-title m-t0"><a href="">Tableaux des bonobos</a></h4>
                <span class="location">Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</span>
                <div class="package-content">
                  <ul class="package-meta">
                    <li><span class="fa fa-handshake-o"></span> Service : Expositon</li>
                  </ul>
                  <div class="d-flex flex-column">
                    <span class="package-price text-primary text-center">5$ <em class="font-weight-normal font-16">(5%)</em></span>
                    <div class="mt-3 d-flex flex-row justify-content-around">
                      <router-link to="reservation" title="Réserver cette offre" class="site-button outline outline-2 radius-xl">Réserver</router-link>
                      <a title="Enregistrer cette offre" href="#" class="site-button outline outline-2 radius-xl site-button-customized"><i class="la la-save"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xl-3 m-b30">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../assets/img/upload_images/offers/exposition.png" alt=""></a>
              </div>
              <div class="dlab-info p-a15 border-1">
                <h4 class="dlab-title m-t0"><a href="">Tableaux des bonobos</a></h4>
                <span class="location">Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</span>
                <div class="package-content">
                  <ul class="package-meta">
                    <li><span class="fa fa-handshake-o"></span> Service : Expositon</li>
                  </ul>
                  <div class="d-flex flex-column">
                    <span class="package-price text-primary text-center">5$ <em class="font-weight-normal font-16">(5%)</em></span>
                    <div class="mt-3 d-flex flex-row justify-content-around">
                      <router-link to="reservation" title="Réserver cette offre" class="site-button outline outline-2 radius-xl">Réserver</router-link>
                      <a title="Enregistrer cette offre" href="#" class="site-button outline outline-2 radius-xl site-button-customized"><i class="la la-save"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <h5 class='w-100 text-info text-center'>Aucune offre trouvée correspond à vos critères de recherche pour le moment !</h5>-->
    <!-- Search Results END -->

    <!-- Most Seen Offers START-->
    <div class="section-full bg-white content-inner dlab-about-1 promotions" id="about-us">
      <div class="container">
        <div class="section-head text-center">
          <h2 class="text-uppercase m-b0">TOP DU MOMENT</h2>
          <p class="font-18">LES OFFRES LES PLUS VUES</p>
        </div>
        <div class="row d-flex">
          <div class="col-md-8 col-sm-8 col-lg-9 form-group align-self-center text-left d-flex flex-wrap justify-content-between">
            <a title="" href="#" class="site-button m-b5">Tableaux des bonobos</a>
            <a title="" href="#" class="site-button m-b5">Visite parc des bonobos</a>
            <a title="" href="#" class="site-button m-b5">Cakes</a>
            <a title="" href="#" class="site-button m-b5">Efes, Zest, Africana</a>
            <a title="" href="#" class="site-button m-b5">Pizza mouritos</a>
<!--            <a title="" href="#" class="site-button m-b5 text-center bg-danger">Aucune offre dispoinible pour le moment !</a>-->
          </div>
          <div class="col-md-4 col-sm-4 col-lg-3 form-group">
            <select class="form-control">
              <option>Populaire</option>
              <option>Moins chère</option>
              <option>Récents</option>
            </select>
          </div>
        </div>
        <div class="row" id="masonry">
          <div class="col-lg-4 col-md-6 col-sm-6 m-b30 card-container">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../assets/img/upload_images/offers/exposition.png" alt="image offre"></a>
                <div class="tr-price">
                  <span><b>5</b>$ <em class="font-weight-normal font-10">(5%)</em></span>
                </div>
              </div>
              <div class="dlab-info p-a20 border-1 text-center">
                <h4 class="dlab-title m-t0"><a href="#">Tableaux des bonobos</a></h4>
                <p>Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</p>
                <div class="tr-btn-info">
                  <a href="#" class="site-button radius-no"><i class="fa fa-location-arrow" aria-hidden="true"></i> Voir</a>
                  <a href="#" class="site-button bg-primary-dark radius-no"><i class="fa fa-info-circle" aria-hidden="true"></i>  Souscrire </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 m-b30 card-container">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../assets/img/upload_images/offers/exposition.png" alt="image offre"></a>
                <div class="tr-price">
                  <span><b>5</b>$ <em class="font-weight-normal font-10">(5%)</em></span>
                </div>
              </div>
              <div class="dlab-info p-a20 border-1 text-center">
                <h4 class="dlab-title m-t0"><a href="#">Tableaux des bonobos</a></h4>
                <p>Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</p>
                <div class="tr-btn-info">
                  <a href="#" class="site-button radius-no"><i class="fa fa-location-arrow" aria-hidden="true"></i> Voir</a>
                  <a href="#" class="site-button bg-primary-dark radius-no"><i class="fa fa-info-circle" aria-hidden="true"></i>  Souscrire </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 m-b30 card-container">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../assets/img/upload_images/offers/exposition.png" alt="image offre"></a>
                <div class="tr-price">
                  <span><b>5</b>$ <em class="font-weight-normal font-10">(5%)</em></span>
                </div>
              </div>
              <div class="dlab-info p-a20 border-1 text-center">
                <h4 class="dlab-title m-t0"><a href="#">Tableaux des bonobos</a></h4>
                <p>Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</p>
                <div class="tr-btn-info">
                  <a href="#" class="site-button radius-no"><i class="fa fa-location-arrow" aria-hidden="true"></i> Voir</a>
                  <a href="#" class="site-button bg-primary-dark radius-no"><i class="fa fa-info-circle" aria-hidden="true"></i>  Souscrire </a>
                </div>
              </div>
            </div>
          </div>
<!--          <h4 class="text-info text-center">Aucune offre disponible pour le moment, veuillez revenir plutard !</h4>-->
        </div>
      </div>
    </div>
    <!-- Most Seen Offers END-->
    <!-- Stats -->
    <div class="section-full bg-white content-inner-2 bgeffect overlay-black-middle" style="background-image:url('src/assets/img/background/bg3.jpg'); background-size:cover" data-0="background-position:0px 0px;" data-end="background-position:0px -100px;">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <div class="add-area">
              <h3>Vous êtes un établisement ?</h3>
              <h2>Devenez <span class="text-primary">Partenaire</span> Yebo</h2>
              <p>Racontez une meilleure histoire.Avantage business.</p>
              <router-link to="partenariat" class="site-button white">Nous réjoindre</router-link>
            </div>
          </div>
          <div class="col-lg-6 col-md-6"></div>
        </div>
      </div>
    </div>
    <!-- Stats END -->
    <!-- Destinations -->
    <div class="section-full bg-white content-inner-1">
      <div class="container">
        <div class="section-head d-flex text-black">
          <div class="flex-grow-1">
            <h2 class="text-uppercase m-b0">Offres Populaires</h2>
            <p class="m-b0">Choisissez votre prochaine réservation</p>
          </div>
          <div class="align-self-center">
            <router-link to="offres" class="site-button button-md pull-right m-t5">Tout Voir</router-link>
          </div>
        </div>
      </div>
      <div class="section-content">
        <div class="destination owl-loaded owl-theme owl-none owl-carousel">
          <div class="item">
            <div class="dlab-box">
              <div class="dlab-media dlab-img-effect zoom-slow dlab-img-overlay2">
                <img src="../assets/img/upload_images/offers/exposition.png" alt="image offre">
                <div class="dlab-info-has p-a20 no-hover ">
                  <div class="dlab-info-has-text">
                    <h3 class="text-white">Tableaux des bonobos<span class="text-primary pull-right">lola ya bonobo</span></h3>
                    <router-link to="offres" class="site-button-link">Voir toutes les offres</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
<!--          <a title="" href="#" class="site-button m-b5 text-center bg-danger">Aucune offre populaire dispoinible pour le moment !</a>-->
        </div>
      </div>
    </div>
    <!-- Destinations END -->
    <div class="section-full bg-white content-inner dlab-about-1 promotions">
      <div class="container">
        <div class="section-head text-black text-center">
          <h2 class="text-uppercase m-b0">OFFRES</h2>
          <p class="font-18">MEILLEURES OFFRES</p>
        </div>
        <div class="row packages">
          <div class="col-sm-6 col-md-6 col-xl-3 m-b30">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../assets/img/upload_images/offers/exposition.png" alt="image offre"></a>
              </div>
              <div class="dlab-info p-a15 border-1">
                <h4 class="dlab-title m-t0"><a href="#">Tableaux des bonobos</a></h4>
                <span class="location">Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</span>
                <div class="package-content">
                  <ul class="package-meta">
                    <li><span class="fa fa-handshake-o"></span> Service : Expositon</li>
                  </ul>
                  <div class="d-flex flex-column">
                    <span class="package-price text-primary text-center">5$ <em class="font-weight-normal font-16">(5%)</em></span>
                    <div class="mt-3 d-flex flex-row justify-content-around">
                      <router-link to="reservation" title="Réserver cette offre" class="site-button outline outline-2 radius-xl">Réserver</router-link>
                      <a title="Enregistrer cette offre" href="#" class="site-button outline outline-2 radius-xl site-button-customized"><i class="la la-save"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xl-3 m-b30">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../assets/img/upload_images/offers/exposition.png" alt="image offre"></a>
              </div>
              <div class="dlab-info p-a15 border-1">
                <h4 class="dlab-title m-t0"><a href="#">Tableaux des bonobos</a></h4>
                <span class="location">Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</span>
                <div class="package-content">
                  <ul class="package-meta">
                    <li><span class="fa fa-handshake-o"></span> Service : Expositon</li>
                  </ul>
                  <div class="d-flex flex-column">
                    <span class="package-price text-primary text-center">5$ <em class="font-weight-normal font-16">(5%)</em></span>
                    <div class="mt-3 d-flex flex-row justify-content-around">
                      <router-link to="reservation" title="Réserver cette offre" class="site-button outline outline-2 radius-xl">Réserver</router-link>
                      <a title="Enregistrer cette offre" href="#" class="site-button outline outline-2 radius-xl site-button-customized"><i class="la la-save"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xl-3 m-b30">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../assets/img/upload_images/offers/exposition.png" alt="image offre"></a>
              </div>
              <div class="dlab-info p-a15 border-1">
                <h4 class="dlab-title m-t0"><a href="#">Tableaux des bonobos</a></h4>
                <span class="location">Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</span>
                <div class="package-content">
                  <ul class="package-meta">
                    <li><span class="fa fa-handshake-o"></span> Service : Expositon</li>
                  </ul>
                  <div class="d-flex flex-column">
                    <span class="package-price text-primary text-center">5$ <em class="font-weight-normal font-16">(5%)</em></span>
                    <div class="mt-3 d-flex flex-row justify-content-around">
                      <router-link to="reservation" title="Réserver cette offre" class="site-button outline outline-2 radius-xl">Réserver</router-link>
                      <a title="Enregistrer cette offre" href="#" class="site-button outline outline-2 radius-xl site-button-customized"><i class="la la-save"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xl-3 m-b30">
            <div class="dlab-box">
              <div class="dlab-media">
                <a href="#"><img src="../assets/img/upload_images/offers/exposition.png" alt="image offre"></a>
              </div>
              <div class="dlab-info p-a15 border-1">
                <h4 class="dlab-title m-t0"><a href="#">Tableaux des bonobos</a></h4>
                <span class="location">Une gallerie d'art au sein du sanctuaire des bonobos retraçant toute l'histoire de ces magniques espèces.</span>
                <div class="package-content">
                  <ul class="package-meta">
                    <li><span class="fa fa-handshake-o"></span> Service : Expositon</li>
                  </ul>
                  <div class="d-flex flex-column">
                    <span class="package-price text-primary text-center">5$ <em class="font-weight-normal font-16">(5%)</em></span>
                    <div class="mt-3 d-flex flex-row justify-content-around">
                      <router-link to="reservation" title="Réserver cette offre" class="site-button outline outline-2 radius-xl">Réserver</router-link>
                      <a title="Enregistrer cette offre" href="#" class="site-button outline outline-2 radius-xl site-button-customized"><i class="la la-save"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
<!--          <h5 class='w-100 text-info text-center'>Aucune offre disponible pour le moment !</h5>-->
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import ContentSlide from './shared/ContentSlide'

export default {
  name: "Index",
  props: {},
  data () {
    return {
      loading: 0,
    }
  },
  components: {
    AppContentSlide : ContentSlide
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([
        "getContentSlides"
    ]),
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
.animate__animated{
  --animate-duration: 1s;
  --animate-delay: 2s;
}
main {}

@media (min-width: 576px) {
  main {}
}

@media (min-width: 768px) {
  main {}
}

@media (min-width: 992px) {
  main {}
}

@media (min-width: 1200px) {
  main {}
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue